import { KeepSelection } from "@/actions/selection/keep-selection"

export default function cartHelper(cart: KeepSelection | null) {
    if (!cart) {
        return {
            isCartEmpty: true,
            sumTotalPriceBeforeDiscount: "0",
            salesTotal: 0,
            currency: "",
            vouchers: [],
            isVoucherApplied: false,
            isSessionDiscounted: false,
            priceWithoutShippingAsNumber: 0
        }
    }

    const isCartEmpty = cart?.checkoutApiSelection?.selection?.items?.length === 0

    // Calculate the total price of all items in the cart before any discounts
    const sumTotalPriceBeforeDiscount =
        cart?.checkoutApiSelection?.selection?.items?.reduce(
            (acc, item) =>
                acc + (item?.priceEachBeforeDiscountAsNumber || 0) * item.quantity,
            0
        )

    const voucherDiscounts =
        cart?.checkoutApiSelection?.selection?.totals?.totalDiscountPriceAsNumber || 0

    const totalDiscountOnItems: number =
        cart?.checkoutApiSelection?.selection?.items?.reduce(
            (acc, item) => acc + (item?.priceEachReductionAsNumber || 0) * item.quantity,
            0
        )
    const itemsTotalPriceAsNumber =
        cart?.checkoutApiSelection?.selection?.totals?.itemsTotalPriceAsNumber || 0
    const salesTotal = voucherDiscounts - totalDiscountOnItems

    const totalDiscountPriceAsNumber =
        cart?.checkoutApiSelection?.selection?.totals?.totalDiscountPriceAsNumber || 0
    const currency = cart?.checkoutApiSelection?.selection?.currency
    const vouchers = cart?.checkoutApiSelection?.selection?.discounts?.vouchers || []
    const isVoucherApplied = vouchers?.length > 0

    const isSessionDiscounted =
        cart?.checkoutApiSelection?.selection?.items?.some(
            item => item?.product?.showAsOnSale
        ) ?? false

    const priceWithoutShippingAsNumber =
        (cart?.checkoutApiSelection?.selection?.totals?.grandTotalPriceAsNumber || 0) -
        (cart?.checkoutApiSelection?.selection?.totals?.shippingPriceAsNumber || 0)

    const shippingCountry =
        cart?.checkoutApiSelection?.selection?.shippingAddress?.country

    return {
        isCartEmpty,
        sumTotalPriceBeforeDiscount,
        salesTotal,
        itemsTotalPriceAsNumber,
        totalDiscountPriceAsNumber,
        currency,
        vouchers,
        isVoucherApplied,
        isSessionDiscounted,
        priceWithoutShippingAsNumber,
        shippingCountry
    }
}

export function getCurrentSelectedState(
    selectedState: string | undefined,
    stateName: string | undefined
): string | null {
    // Check if state is available in location first
    if (stateName) {
        return stateName
    }

    // If a state is already selected, return it
    if (selectedState) {
        return selectedState
    }

    // If no states are found, return null
    return null
}
